<template>
  <div class="kit-tabs">
    <ETabs v-model="selectedTab" :vertical="$vuetify.breakpoint.mdAndUp">
      <div v-for="tab in tabs" :key="tab.value" :name="tab.name">
        <KitSummary v-if="showTab(tab, KIT_TABS.SUMMARY)" />
        <KitMetrics v-if="showTab(tab, KIT_TABS.METRICS)" />
        <KitZohoDeskTickets v-if="showTab(tab, KIT_TABS.TICKETS)" />
      </div>
    </ETabs>
  </div>
</template>

<script>
import KitZohoDeskTickets from "@/components/kits/tabs/KitZohoDeskTickets"
import KitSummary from "@/components/kits/tabs/KitSummary"
import KitMetrics from "@/components/kits/tabs/KitMetrics"
import { mapStores } from "pinia"
import { useKitMetricsStore } from "@/stores/kitMetrics"
import { useKitSummaryStore } from "@/stores/kitSummary"

const KIT_TABS = {
  SUMMARY: 0,
  METRICS: 1,
  TICKETS: 2,
}

export default {
  name: "KitTabsContainer",
  components: {
    KitZohoDeskTickets,
    KitSummary,
    KitMetrics,
  },
  data() {
    return {
      selectedTab: KIT_TABS.SUMMARY,
      KIT_TABS,
    }
  },
  computed: {
    ...mapStores(useKitMetricsStore, useKitSummaryStore),
    tabs() {
      return [
        {
          name: "Summary",
          value: KIT_TABS.SUMMARY,
        },
        {
          name: "Metrics",
          value: KIT_TABS.METRICS,
        },
        {
          name: "Tickets",
          value: KIT_TABS.TICKETS,
        },
      ]
    },
  },
  mounted() {
    this.kitMetricsStore.fetchMetrics()
  },
  beforeDestroy() {
    this.kitMetricsStore.$reset()
    this.kitSummaryStore.$reset()
  },
  methods: {
    showTab(currentTab, tabId) {
      return currentTab.value === tabId
    },
  },
}
</script>

<style lang="scss">
.kit-tabs {
  .e-tabs .tab-content {
    padding-bottom: 0px;
  }

  .e-tabs .tab-content,
  .e-tabs .tab-content > div {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 45px);
    overflow: hidden;
  }

  .e-tabs__item {
    display: flex;
    padding: 0.5rem 1rem;
    min-width: 100px;
  }
}
</style>
